<template>
    <div class="agreement">
        <agreement-modal
            :title="'서비스 이용약관'"
            :url="info[type].url"
            @close="closeAgreementModal"
            v-if="agreementContentsModal"
        />
        <div class="header" @click="gohome">← 홈화면으로 돌아가기</div>
        <div class="wrapper">
            <div class="agree-area">
                <div class="title">건강 측정 체험을 위해<br><span style="font-weight: 700;">약관 동의가 필요합니다</span></div>
                <div class="agree-component" style="margin-top: 4.6vh;">
                    <div class="text1">
                        <div class="row" @click="allAgreeF">
                            <img v-if="!allAgree" style="width: 3vw;" src="../../assets/showcase/xi/check_box_inactive.png" />
                            <img v-else style="width: 3vw;" src="../../assets/showcase/xi/check_box_active.png" />
                            <span>모두 동의합니다</span>
                        </div>
                        
                    </div>
                    <div class="text2">
                        <div class="row">
                            <img @click="agree1 = !agree1" v-if="!agree1" style="width: 3vw;" src="../../assets/showcase/xi/check_box_inactive.png" />
                            <img @click="agree1 = !agree1" v-else style="width: 3vw;" src="../../assets/showcase/xi/check_box_active.png" />
                            <span @click="agree1 = !agree1">[필수] 만 14세 이상입니다.</span>
                        </div>
                    </div>
                    <div class="text2">
                        <div class="row">
                            <img @click="agree2 = !agree2" v-if="!agree2" style="width: 3vw;" src="../../assets/showcase/xi/check_box_inactive.png" />
                            <img @click="agree2 = !agree2" v-else style="width: 3vw;" src="../../assets/showcase/xi/check_box_active.png" />
                            <span @click="agree2 = !agree2">[필수] 서비스 이용약관 동의</span>
                        </div>
                        <img style="width: 5vw;" @click="agreementContentsView(0)" src="../../assets/showcase/xi/right_arrow.png" />
                    </div>
                    <div class="text2">
                        <div class="row">
                            <img @click="agree3 = !agree3" v-if="!agree3" style="width: 3vw;" src="../../assets/showcase/xi/check_box_inactive.png" />
                            <img @click="agree3 = !agree3" v-else style="width: 3vw;" src="../../assets/showcase/xi/check_box_active.png" />
                            <span @click="agree3 = !agree3">[필수] 개인정보 수집 및 이용동의</span>
                        </div>
                        
                        <img style="width: 5vw;" @click="agreementContentsView(1)" src="../../assets/showcase/xi/right_arrow.png" />
                    </div>
                    <div class="text2">
                        <div class="row">
                            <img @click="agree4 = !agree4" v-if="!agree4" style="width: 3vw;" src="../../assets/showcase/xi/check_box_inactive.png" />
                            <img @click="agree4 = !agree4" v-else style="width: 3vw;" src="../../assets/showcase/xi/check_box_active.png" />
                            <span @click="agree4 = !agree4">[필수] 위치기반 서비스 이용동의</span>
                        </div>
                        <img style="width: 5vw;" @click="agreementContentsView(2)" src="../../assets/showcase/xi/right_arrow.png" />
                    </div>
                </div>
                <div :class="agree1 && agree2 && agree3 && agree4 ? 'button-next-active': 'button-next'" style="margin-top: 4.6vh;" @click="next">다음</div>
            </div>
        </div>
    </div>
</template>

<script>

import AgreementModal from '@/components/showcase/AgreementModal';
export default {
    components: { AgreementModal },
    data: function()
    {
        return {
            timerId: null,
            allAgree: false,
            agree1: false,
            agree2: false,
            agree3: false,
            agree4: false,
            agreementContentsModal: false,
            type: 0,
            info: [
                {type: 0, url: 'https://policy.soldoc.co.kr/terms?back=false&full=true'},
                {type: 1, url: 'https://policy.soldoc.co.kr/use?back=false&full=true'},
                {type: 1, url: 'https://policy.soldoc.co.kr/location?back=false&full=true'}
            ]
        }
    },
     methods: {
        resetTimeoutCount: function () {
            clearTimeout(this.timeoutId);
            this.timeoutId = setTimeout(this.gohome, 30000);
        },
        clearTimer: function()
        {
            clearTimeout(this.timeoutId);
            this.timerId = null;
        },
        gohome: function() {
            this.clearTimer();
            window.location.href  = '/xi/home'
        },
        allAgreeF: function()
        {
            this.allAgree = !this.allAgree;
            this.agree1 = this.allAgree;
            this.agree2 = this.allAgree;
            this.agree3 = this.allAgree;
            this.agree4 = this.allAgree;
        },
        agreementContentsView: function(type)
        {
            this.type = type;
            this.agreementContentsModal = true;
        },
        closeAgreementModal: function()
        {
            this.type = 0;
            this.agreementContentsModal = false;
        },
        next: function()
        {
            if(this.agree1 && this.agree2 && this.agree3 && this.agree4)
            {
                this.$emit('next', 1)
            }
            
        }
    },
    watch: {
        agree1: function()
        {
            if(!this.agree1)
            {
                this.allAgree = false;
            }
        },
        agree2: function()
        {
            if(!this.agree2)
            {
                this.allAgree = false;
            }
        },
        agree3: function()
        {
            if(!this.agree3)
            {
                this.allAgree = false;
            }
        },
        agree4: function()
        {
            if(!this.agree4)
            {
                this.allAgree = false;
            }
        }
    }
}
</script>

<style scoped>
    .agreement {
        width: 100%;
        height: 100vh;
        overflow: hidden;    
    }
    .header {
        height: 9vh;
        width: 100%;
        font-size: 2vh;
        color: var(--xi-dark-blue, #173C55);
        font-family: Pretendard;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        letter-spacing: -1.12px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding-left: 5%;
        box-sizing: border-box;
    }
    .agree-area {
        box-sizing: border-box;
        padding: 8vh 16vw;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        border-top: 2px solid var(--xi-gray-2, #C4CBD2);
    }
    .wrapper {
        padding: 6.2vh 5vw;
        width: 100%;
        height: 100%;
        box-sizing: border-box;
    }
    .title {
        color: var(--xi-dark-gray, #131415);
        text-align: center;
        font-family: Pretendard;
        font-size: 3vh;
        font-style: normal;
        font-weight: 500;
        line-height: 131%;
        letter-spacing: -2.64px;
    }
    .button-next {
        border-radius: 16px;
        background: var(--xi-gray-1, #F0F1F4);
        font-size: 1.8vh;
        width: 27vw;
        aspect-ratio: 3;
        display: flex;
        justify-content: center;
        align-items: center;
        color: var(--xi-gray-2, #C4CBD2);
        text-align: center;
        font-family: Pretendard;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }
    .button-next-active {
        border-radius: 16px;
        background: var(--xi-gray-1, #F0F1F4);
        font-size: 1.8vh;
        width: 27vw;
        aspect-ratio: 3;
        display: flex;
        justify-content: center;
        align-items: center;
        color: var(--xi-dark-gray, #131415);
        text-align: center;
        font-family: Pretendard;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        cursor: pointer;
    }
    .agree-component {
        display: flex;
        flex-direction: column;
        width: 100%;
        justify-content: flex-start;
        align-items: flex-start;
    }
    .text1{
        color: var(--xi-dark-gray, #131415);
        font-family: Pretendard;
        font-size: 2.1vh;
        font-style: normal;
        font-weight: 700;
        letter-spacing: -1.12px;
        height: 6vh;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        box-sizing: border-box;
        padding-left: 5vw;
        border-radius: 16px;
        background: var(--xi-gray-1, #F0F1F4);
        width: 100%;
    }
    .text2 {
        color: var(--xi-dark-gray, #131415);
        font-family: Pretendard;
        font-size: 1.8vh;
        font-style: normal;
        font-weight: 500;
        letter-spacing: -0.96px;
        height: 5vh;
        display: flex;
        justify-content: space-between;
        align-items: center;
        box-sizing: border-box;
        padding-left: 5vw;
        width: 100%;
        margin-top: 0.9vh;
    }
    .row {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap: 5vw;
    }
</style>


// WEBPACK FOOTER //
// src/components/showcase/Agreement.vue